/**
 * Контактные данные. Заполни перед production launch'ем — это видят
 * клиенты на landing'е (ContactStrip).
 *
 * Формат WhatsApp/Phone: международный без знака `+` и без пробелов,
 * например "77071234567" (для wa.me/77071234567).
 *
 * Если контакт не указан (= placeholder TODO_*), кнопка скрывается.
 */

export const CONTACTS = {
  whatsapp: "77059750654",
  phone: "77059750654",
  telegram: "eroloft",
  instagram: "kz_advice",
  email: "erbolat.12.12.96@gmail.com",
} as const;

export const DEMO_URL = "https://alem.e-menu.bar/menu/";

/**
 * Скачать Windows-кассу. Ведёт на edge-функцию `api/cashier-download.ts`,
 * которая редиректит на .exe ПОСЛЕДНЕГО релиза (имя файла с номером версии,
 * поэтому прямая ссылка на GitHub протухала бы после каждого OTA-выпуска).
 */
export const CASHIER_DOWNLOAD_URL = "/api/cashier-download";

export function isPlaceholder(value: string): boolean {
  return value.startsWith("TODO_") || value === "";
}
